"use client";

import { RomaReserveSheetButton } from "@/components/roma/dark-funnel/roma-reserve-sheet-button";
import { useMarketingLocationContext } from "@/lib/marketing-location-context";

// Menu item-modal footer. This occupies the slot where Owner.com puts its
// "Add to order" control: reserve is the funnel goal, the external order link
// is the live "want it now" path.
//
// This footer renders inside a portaled dialog, outside the /menu dark-subpage
// scrub, so every surface below is painted from semantic tokens (dark on the
// Roma funnel via the html-level token block, light otherwise).
export function MenuItemCtaFooter({ itemName }: { itemName: string }) {
  const { siteConfig } = useMarketingLocationContext();
  const orderUrl = siteConfig.orderUrl;
  const orderIsExternal = orderUrl?.startsWith("http") ?? false;
  const orderProps = orderIsExternal
    ? { target: "_blank" as const, rel: "noopener noreferrer" }
    : {};
  const orderButtonLabel =
    orderUrl && /grubhub/i.test(orderUrl) ? "Order on Grubhub" : "Order online";
  const reservationUrl = siteConfig.reservationUrl;

  if (!reservationUrl && !orderUrl) {
    return null;
  }

  return (
    <div
      className={`mt-6 grid grid-cols-1 gap-2 border-t border-[var(--border)] pt-5 ${
        reservationUrl && orderUrl ? "sm:grid-cols-2" : ""
      }`}
    >
      {reservationUrl ? (
        <RomaReserveSheetButton
          fallbackHref={reservationUrl}
          trackLocation="menu_item_modal"
          trackLabel={itemName}
          className="flex min-h-12 items-center justify-center rounded-[10px] bg-[var(--roma-burgundy)] px-4 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--roma-burgundy-deep)] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--card)] focus-visible:ring-[color:var(--roma-terracotta)] dark:focus-visible:ring-[color:var(--roma-red-text)]"
        >
          Reserve a table
        </RomaReserveSheetButton>
      ) : null}
      {orderUrl ? (
        <a
          href={orderUrl}
          {...orderProps}
          data-track="order_started"
          data-track-location="menu_item_modal"
          data-track-label={itemName}
          className="flex min-h-12 items-center justify-center rounded-[10px] border border-[var(--border)] px-4 text-[15px] font-semibold text-[var(--card-foreground)] transition-colors hover:border-[var(--roma-terracotta)] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--card)] focus-visible:ring-[color:var(--roma-terracotta)] dark:focus-visible:ring-[color:var(--roma-red-text)]"
        >
          {orderButtonLabel}
        </a>
      ) : null}
    </div>
  );
}

export default MenuItemCtaFooter;
